import DossierItemForm from "components/dossiers/dossierFollowUp/DossierItemForm";
import EditModal from "components/forms/EditModal";
import React from 'react'
import { connect } from "react-redux";
import { findEntity } from "selectors/entities";
import { List, Segment } from 'semantic-ui-react'
import { updateEntity } from "../../../actions/entities";
import { updateUI } from "../../../actions/ui";
import { loadDraft } from "../../../drafts";
import { getCurrentEmployment } from "../../../selectors/employments";
import { getCurrentOffice } from "../../../selectors/offices";
import AttachmentNode from "./AttachmentNode";
import ConsultationNode from "./ConsultationNode";
import DossierCreationNode from "./DossierCreationNode";
import DossierNode from "./DossierNode";
import NoteNode from "./NoteNode";

const editModalKey = (dossierItemId) => `RestoredNoteEdit-${dossierItemId}`

const editableItemId = (dossierItem) => {
  switch (dossierItem.dossierItemType) {
    case 'note': return dossierItem.id
    case 'consultation': return dossierItem.noteId
    default: return null
  }
}

class DossierItemListItem extends React.Component {

  componentDidMount() {
    const id = editableItemId(this.props.dossierItem)
    if (id) this.props.restoreDraft(id)
  }

  render() {
    const dossierItem = this.props.dossierItem
    const editId = editableItemId(dossierItem)

    return [
      editId &&
        <EditModal key="restoreEditModal"
                   entityName="dossierItem"
                   EntityForm={DossierItemForm}
                   entityId={editId}
                   defaultKey={editModalKey(editId)}
                   header={this.calculateRestoreModalHeader(dossierItem)}
                   trigger={() => null}/>,
      <List.Item key={dossierItem.id} as={Segment} basic clearing>
        <List.Content>
          {this.renderNode(dossierItem)}
        </List.Content>
      </List.Item>
    ]
  }

  calculateRestoreModalHeader(dossierItem){
    switch (dossierItem.dossierItemType) {
      case 'note': return `${this.props.patientName} ${I18n.t('components.dossier_item.note')}`
      case 'consultation':
        return `${this.props.patientName} ${this.props.consultation?.consultationType?.name || ''} ${I18n.l("date.formats.short_human_readable", dossierItem.time) || ''}`
      default: return null
    }
  }

  renderNode = (node) => {
    const { applyNodeStyle } = this.props

    let nodeColor = node.creatorId === 74 ? '#eb144c' : '#9fe1e7'

    let nodeStyle = applyNodeStyle ?
      { borderTop: '4px', borderTopColor: nodeColor, borderTopStyle: 'solid' } :
      null

    switch(node.dossierItemType) {
      case 'consultation':
        return <ConsultationNode key={node.key} consultationId={node.consultationId} {...this.props} nodeStyle={nodeStyle}/>
      case 'creation':
        return <DossierCreationNode key={node.key} dossierId={node.dossierId} {...this.props}/>
      case 'dossier':
        return <DossierNode key={node.key} dossierId={node.dossierId} {...this.props}/>
      case 'note':
        return <NoteNode time={node.time} {...this.props} dossierId={node.dossierId} nodeStyle={nodeStyle}/>
      case 'attachment':
        return <AttachmentNode time={node.time} {...this.props} nodeStyle={nodeStyle}/>
      default:
        return <h1>no node</h1>
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  let office = getCurrentOffice(state)
  let currentEmployment = getCurrentEmployment(state)
  let applyNodeStyle = office.hiddenPreferences && office.hiddenPreferences.includes("colorDossierNodes")

  let dossier = findEntity(state, 'dossier', ownProps.dossierItem?.dossierId)
  let consultation = findEntity(state, 'consultation', ownProps.consultationId)
  let patient = findEntity(state, 'contact', dossier && dossier.patientId)
  const patientName = patient? `${patient?.firstName} ${patient?.lastName}:` : ''

  return {
    applyNodeStyle: applyNodeStyle,
    showInlineImages: currentEmployment?.showInlineImages !== false,
    showInlinePdfs: currentEmployment?.showInlinePdfs !== false,
    patientName: patientName,
    consultation: consultation
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    restoreDraft: (id) => dispatch(async (dispatch, getState) => {
      const employment = getCurrentEmployment(getState())
      if (!employment?.draftEncryptionKey) return

      const draft = await loadDraft(`entities.dossierItem.byId.${id}`, employment)
      if (!draft || !draft.data) return

      dispatch(updateEntity('dossierItem', draft.data))
      dispatch(updateUI(editModalKey(id), 'modalOpen', true))
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DossierItemListItem);
